import { render, staticRenderFns } from "./BulletinBoard.vue?vue&type=template&id=a5210860&scoped=true&"
import script from "./BulletinBoard.vue?vue&type=script&lang=js&"
export * from "./BulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./BulletinBoard.vue?vue&type=style&index=0&id=a5210860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5210860",
  null
  
)

export default component.exports